import { render } from "./PageNumber6Tiles.vue?vue&type=template&id=e01dac40"
import script from "./PageNumber6Tiles.vue?vue&type=script&lang=js"
export * from "./PageNumber6Tiles.vue?vue&type=script&lang=js"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__